class MdcDot {
  static delay = function (ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  static getFirstObject = function (obj) {
    for (let key in obj) {
      if (obj.hasOwnProperty(key)) {
        return obj[key];
      }
    }
    return null; // Return null if no object is found
  }

  static stageClass(stage) {
    stage = stage.toLowerCase();
    let stageClass = 'primary';
    switch (stage) {
      case 'cold' :
        stageClass = 'primary';
        break;
      case 'hot' :
        stageClass = 'danger';
        break;
      case 'warm' :
        stageClass = 'warning';
        break;
    }
    return stageClass;
  }

  static sourceClass(source) {
    const app = PreBuilt;
    if (!app.isEmpty(source)) {
      source = source.toLowerCase();
      let sourceClass = 'primary';
      switch (source) {
        case 'bulk_uploader' :
          source = 'uploader';
          sourceClass = 'secondary';
          break;
        case 'webform' :
          sourceClass = 'light';
          break;
        case 'app' :
          sourceClass = 'primary';
          break;
      }
      return sourceClass;
    }

    return '';
  }

  static activityTypeClass(type) {
    type = type.toLowerCase();
    let activityTypeClass;
    switch (type) {
      case 'visit' :
        activityTypeClass = 'globe-pointer';
        break;
      case 'click' :
        activityTypeClass = 'envelope-circle-check';
        break;
      case 'open' :
        activityTypeClass = 'envelope-open-text';
        break;
      case 'delivered' :
        activityTypeClass = 'inbox-out';
        break;
    }
    return activityTypeClass;
  }

  static unmailableReason(row) {
    let unmailableReason = '';
    if (row.unmailableType === 'unsubscribe') {
      unmailableReason = 'This contact has unsubscribed from emails';
    }

    if (row.unmailableType === 'bounce') {
      unmailableReason = `${row.unmailableReason}`;
    }

    if (row.unmailableType === 'kickbox') {
      unmailableReason = `${row.unmailableReason}`;
    }

    return unmailableReason;
  }

  static unmailableType(row) {
    let unmailableReason = '';
    if (row.unmailableType === 'unsubscribe') {
      unmailableReason = '';
    }

    if (row.unmailableType === 'bounce') {
      unmailableReason = `This contact is in bounce state since ${row.unmailableDate}`;
    }

    return unmailableReason;
  }

  static getLeadSelection() {
    const app = PreBuilt;
    const $all = $('[data-lead-action=select-all-leads]');
    const $allCount = $all.attr('data-active');
    const $allOnPage = $('[data-lead-action=select-all-leads-on-page]');
    const $allOnPageCount = $allOnPage.attr('data-active');

    if (!app.isEmpty($allCount) && $allCount !== 'false') {
      return {selection: 'all', count: $allCount};
    }

    if (!app.isEmpty($allOnPageCount) && $allOnPageCount !== 'false') {
      return {selection: 'allOnPage', count: $allOnPageCount};
    }

    return {selection: 'none', count: 0};
  }

  static async bulkProgressBar(action, requestData, totalRecordsCount, pageSize) {
    const app = PreBuilt;
    const paginator = new Paginator(pageSize);
    paginator.setRecordsCount(totalRecordsCount);

    //
    // this.paginatedUrl = new PaginatedUrl(`/api/mdcdot/leads`, 1, pageSize);
    // const results = await this.app.apis['mdcdot'].leads.list(this.paginatedUrl.getPageUrl(1));

    const totalPages = paginator.getTotalPages();

    let messages = [];
    for (let i = 0; i < totalPages; i++) {
      const startIndex = (i * pageSize) + 1;
      let endIndex = pageSize * (i + 1);
      endIndex = Math.min(endIndex, totalRecordsCount);
      messages.push(`Processing ${startIndex} - ${endIndex} of ${totalRecordsCount}`)
    }

    app.progressModal = app.infoModal(
        'Mass Actions Progress',
        `<div class="progressbar-container"></div>`,
        {
          'dialogClass': 'modal-dialog-scrollable modal-lg',
          footerText: '<span class="fw-semibold text-danger">Do not refresh browser or close this window</span>'
        }
    );

    app.progressModal.promise.then(function (response) {
      console.log(response);
    });

    app.progressModal.find('.btn-confirm-close').addClass('d-none');
    const progress = new ProgressBar(app.progressModal.find('.progressbar-container'), messages);

    // Function to create a delay
    const delay = function (ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    }

    let searchParams = !app.isEmpty(window['leadSearchParams']) ? window['leadSearchParams'] : {};
    searchParams['page'] = 0;
    searchParams['limitPerPage'] = pageSize;
    searchParams['onlyIds'] = true;

    let csvContent;
    if (action === 'export') {
      const headers = _.keys(MdcDot.getFirstObject(window.leadsIndexById));
      csvContent = "data:text/csv;charset=utf-8,";
      csvContent += headers.join(",") + "\r\n";
    }

    for (let i = totalPages; i > 0; i--) {
      progress.updateOneStep();
      const page = i;
      try {
        await delay(2000); // Wait for 1 second
        let leadSearchParams = app.clone(searchParams);
        leadSearchParams['page'] = page;
        if (action === 'tags') {
          const leadsList = await app.apis['mdcdot'].leads.list(`/api/mdcdot/leads`, 'id', 'ASC', leadSearchParams);
          requestData.ids = leadsList.result;
          await app.apis['mdcdot'].tagMultiple(requestData);
        }

        if (action === 'delete') {
          const leadsList = await app.apis['mdcdot'].leads.list(`/api/mdcdot/leads`, 'id', 'ASC', leadSearchParams);
          requestData.ids = leadsList.result;
          await app.apis['mdcdot'].leads.delete(requestData);
        }

        if (action === 'campaign') {
          const leadsList = await app.apis['mdcdot'].leads.list(`/api/mdcdot/leads`, 'id', 'ASC', leadSearchParams);
          requestData.ids = leadsList.result;
          await app.apis['mdcdot'].campaignMultiple(requestData);
        }

        if (action === 'export') {
          delete leadSearchParams['onlyIds'];
          const leadsList = await app.apis['mdcdot'].leads.list(`/api/mdcdot/leads`, 'id', 'ASC', leadSearchParams);

          _.each(leadsList.result, rowArray => {
            let row = _.values(rowArray).join(",");
            csvContent += row + "\r\n";
          });
        }
      } catch (e) {
        console.log(e);
      }

      app.initTooltip();
    }

    progress.remove();
    app.hideModal(app.progressModal);
    if (action === 'campaign') {
      app.hideModal(app.asignLeadsToCampaignModal);
    }

    if (action === 'export') {
      const encodedUri = encodeURI(csvContent);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute("download", "data.csv");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }

  }
}

class LeadsList extends TableList {
  /**
   * Constructs an instance of the CampaignList class.
   */
  constructor(app, container, listRow, sortBy, sortByDirection) {
    super(app, container, listRow, false);
    if (!app.isEmpty(sortBy)) {
      this.sortBy = sortBy;
    } else {
      this.sortBy = 'dateCreated';
    }

    if (!app.isEmpty(sortByDirection)) {
      this.sortByDirection = sortByDirection;
    } else {
      this.sortByDirection = 'DESC';
    }

    this.searchParams = !app.isEmpty(window['leadSearchParams']) ? window['leadSearchParams'] : null;

    this.container.empty();
    this.paginator = new Paginator(100);
    this.renderList = this.renderList.bind(this);
    this.paginatedUrl = new PaginatedUrl(`/api/mdcdot/leads`, 1, 100);
    this.buttonsPaginator = new ButtonsPaginator($(".paginator-container"), this.renderList);
    this.renderList(1);
  }

  prepareRow(row) {
    const page = _.template(this.app.templates[this.listRow]);

    const defaults = {'count': ''};
    row = {...defaults, ...row};

    let unmailableReason = MdcDot.unmailableReason(row);

    let pageData = {
      ...row,
      ...{'unmailableReason': unmailableReason},
      ...{stageClass: MdcDot.stageClass(row.stage)},
      ...{stageInfo: row.stageInfo},
      ...{source: row.source === 'bulk_uploader' ? 'uploader' : row.source},
      ...{sourceClass: MdcDot.sourceClass(row.source)},
      ...{date_created: moment(moment.utc(row.dateCreated.date).toDate()).format('lll')}
    };

    const $page = $(page(pageData));

    return $page;
  }

  async renderList(page) {
    const self = this;
    const $listContainer = this.container
    const $parentContainer = $('.leads-container');
    let leads = [];
    this.isRendering = true;

    if (this.app.isEmpty(window.leadsIndexById)) {
      window.leadsIndexById = {};
    }

    try {
      if (page) {
        $listContainer.empty();
        if (this.lazyloader) {
          this.lazyloader.destroy();
        }
        this.showLoader({
          id: null,
          unmailableType: '',
          unmailable: false,
          unmailableReason: '',
          email: this.staticPH,
          source: this.staticPH,
          sourceClass: 'warning',
          firstName: this.staticPH,
          stage: '',
          stageClass: 'primary',
          score: '0',
          date_created: this.staticPH,
          lastName: this.staticPH
        });
        $parentContainer.find('.btn-sort').attr('disabled', 'disabled');

        const $pageTitle = $('[data-count-all-leads]');
        $pageTitle.addClass('animated flash');
        const response = await this.app.apis['mdcdot'].leads.list(this.paginatedUrl.getPageUrl(page), this.sortBy, this.sortByDirection, this.searchParams);
        this.apiResponse = response;
        this.lazyloader = new LazyLoader(this.app, this.container, this.renderList);

        $pageTitle.removeClass('animated flash');
        $pageTitle.text(`(${response.total})`);
        $pageTitle.data('count-all-leads', response.total)
        $('.rows-selector-wrapper').find('button[data-lead-action]').removeAttr('disabled');
        $parentContainer.find('.btn-sort').removeAttr('disabled');

        this.paginatedUrl.setPageCount(response.pages);
        this.paginator.setData(response.result);
        this.paginator.setCurrentPage(1);
        this.buttonsPaginator.setTotalPages(response.pages);
        leads = this.paginator.getCurrentPage();
      } else {
        leads = this.paginator.getNextPage();
      }

      this.removeLoader();

      if (!this.app.isEmpty(leads)) {
        _.each(leads, function (row) {
          window.leadsIndexById[row.id] = row;
          let $row = self.prepareRow(row);
          $row.appendTo($listContainer);
        });

        this.app.initTooltip();

        this.isRendering = false;

        let hasMoreData = this.paginator.hasMoreData();
        return hasMoreData;

      } else if (this.app.isEmpty(window.leadsIndexById)) {
        let message = 'No Leads found';
        let description = 'You have no leads';
        if (this.apiResponse.error) {
          message = 'No instance connected';
          description = 'Please select an instance or contact help for support'
        }

        const noRecordsOptions = {
          title: message,
          class: 'available-mdcdot-table-height no-leads',
          description: description,
          help: {
            text: 'Need Help ?',
            onClick: () => {
              console.log('Help clicked');
              // Code to open help documentation or contact support
            }
          }
        };
        const placeholder = new NoRecordsPlaceholder(this.app, this.container.closest('.table-responsive'), noRecordsOptions);
        placeholder.render();
      }

    } catch (error) {
      console.error("Error occurred during operation:", error);
    }
  }
}

class LeadActivity extends TableList {
  /**
   * Constructs an instance of the CampaignList class.
   */
  constructor(app, container, id, listRow, sortBy = 'timestamp', sortByDirection = 'DESC', paginationCount = 5000) {
    super(app, container, listRow, false);
    this.sortBy = sortBy;
    this.sortByDirection = sortByDirection;
    this.container.empty();

    this.searchParams = !app.isEmpty(window['activitySearchParams']) ? window['activitySearchParams'] : null;

    this.paginator = new Paginator(paginationCount);
    this.renderList = this.renderList.bind(this);
    this.leadId = id;
    this.paginatedUrl = new PaginatedUrl(`/api/mdcdot/lead/${id}/activity`, 1, paginationCount);
    try {
      this.lazyloader = new LazyLoader(app, this.container, this.renderList);
    } catch (e) {
      console.log(e);
    }

  }

  prepareRow(row) {
    const page = _.template(this.app.templates[this.listRow]);

    const defaults = {};
    row = {...defaults, ...row};

    const activityTemplates = {
      delivered: (lead, email, campaignName, emailVariant) =>
          `${emailVariant ? 'Email Variant' : 'Email'} "${buildButton(lead.id, email, emailVariant)}" was delivered to <span class="fw-semibold">${lead.name}</span> as part of the "${campaignName}" campaign.`,

      open: (lead, email, campaignName, emailVariant) =>
          `<span class="fw-semibold">${lead.name}</span> opened the ${emailVariant ? 'email variant' : 'email'} "${buildButton(lead.id, email, emailVariant)}" from the "${campaignName}" campaign.`,

      click: (lead, email, campaignName, emailVariant) =>
          `<span class="fw-semibold">${lead.name}</span> clicked a link in the ${emailVariant ? 'email variant' : 'email'} "${buildButton(lead.id, email, emailVariant)}" from the "${campaignName}" campaign.`,

      visit: (lead, email, campaignName, emailVariant) =>
          `<span class="fw-semibold">${lead.name}</span> visited your website after interacting with the ${emailVariant ? 'email variant' : 'email'} "${buildButton(lead.id, email, emailVariant)}" from the "${campaignName}" campaign.`,

      bounce: (lead, email, campaignName, emailVariant) =>
          `<span class="fw-semibold">${lead.name}</span> triggered a bounce after the ${emailVariant ? 'email variant' : 'email'} "${buildButton(lead.id, email, emailVariant)}" from the "${campaignName}" campaign failed to deliver.`,

      unsubscribe: (lead, email, campaignName, emailVariant) =>
          `<span class="fw-semibold">${lead.name}</span> unsubscribed after receiving the ${emailVariant ? 'email variant' : 'email'} "${buildButton(lead.id, email, emailVariant)}" from the "${campaignName}" campaign.`
    };



    function buildButton(leadId, email, emailVariant) {
      if (emailVariant) {
        return `<button class="btn btn-sm" data-activity-action="email-variant" data-lead-id="${leadId}" data-email-variant-id="${emailVariant.id}" data-aimi-email-campaign-id="${emailVariant.aimiEmailCampaignId}">
          ${emailVariant.id} <i class="fa-light fa-eye"></i> 
          </button>`;
      } else {
        return `<button class="btn btn-sm m-0 p-0" data-activity-action="email" data-lead-id="${leadId}" data-id="${email.id}">
          ${email.name} <i class="fa-light fa-eye"></i>
        </button>`;
      }
    }



    const campaignName = row.sequence ? row.sequence.name : null;
    const emailData = row.email ? row.email : null;
    const emailVariantData = row.emailVariant ? row.emailVariant : null;
    let activityDescription = '';
    if(!this.app.isEmpty(campaignName)) {
      if(!this.app.isEmpty(emailData) || !this.app.isEmpty(emailVariantData)) {
        activityDescription = activityTemplates[row.type](row.hash.lead,emailData, campaignName, emailVariantData);
      }
    }

    let pageData = {
      ...row,
      ...{lead: {id: this.leadId}},
      ...{'activityDescription' : activityDescription},
      ...{url: Utils.removeLeadParameter(row.url)},
      ...{'typeIcon': MdcDot.activityTypeClass(row.type)},
      ...{timestamp: moment(moment.utc(row.timestamp.date).toDate()).format('lll')}
    };

    if(pageData.pageViews) {
      pageData.start = moment(moment.utc(row.start.date).toDate()).format('lll');
      pageData.end = moment(moment.utc(row.end.date).toDate()).format('lll');
      _.each(pageData.pagesViewed, function (page) {
        page.timestamp = moment(moment.utc(page.timestamp.date).toDate()).format('lll');
      })
    }

    const $page = $(page(pageData));

    return $page;
  }

  static async filterCallback(response = {}) {
    const app = PreBuilt;

    NoRecordsPlaceholder.destroy();
    Toast.destroy();
    $('.filter-activity-container').removeClass('position-sticky');

    let message = [];
    const messageStatic = `Showing results for  `;
    if (!app.isEmpty(response.activityTypes)) {
      const scores = response.activityTypes.join(',')
      message.push(` <span class="fw-semibold">activities ${scores}</span>`)
    }

    message = messageStatic + message.join(' and ');
    app.ActivityToast = new Toast(app, $('.activities-container'), {
      'toastClass': 'mb-4 position-sticky top-0',
      'message': message, closeButton: {
        text: 'Clear Filter',
        onClick: () => {
          Toast.destroy();
          $('[data-activity-action="filter"]').removeClass('btn-outline-primary');
          $('.filter-activity-container').addClass('position-sticky');
          window.mdcdotLead.updateTabActivity();
        }
      }
    });
    app.ActivityToast.render();
  }

  async renderList() {
    const self = this;
    const $listContainer = this.container;
    let activities = [];
    this.isRendering = true;

    if (this.app.isEmpty(window.emailsIndexById)) {
      window.emailsIndexById = {};
    }

    try {
      this.showLoader({
        typeIcon: 'wait',
        "id": '',
        "returning": '',
        "download": '',
        "userId": '',
        "hash": "",
        "pages": 0,
        "durations": 0,
        "visits": 0,
        "emailOpens": 0,
        "type": this.staticPH,
        "timestamp": this.staticPH,
        "isp": '',
        "city": '',
        "state": null,
        "country": null,
        "provider": null,
        "activity": "email",
        "visitId": 0,
        "emailClicks": 0,
        "emailId": '',
        "emailVariantId" : '',
        "sequenceId": '',
        "url": "",
        "emailAddress": this.staticPH,
        "emailDomain": '',
        "siteId": 0,
        "videoId": null,
        "orderId": 0,
        "foreignId": "0",
        "smsMessageId": null
      });

      if (this.paginator.currentPage === null) {
        const response = await this.app.apis['mdcdot'].leads.list(this.paginatedUrl.getCurrentPageUrl(true), this.sortBy, this.sortByDirection, this.searchParams);
        this.total = response.total;
        this.paginatedUrl.setPageCount(response.pages);
        this.paginator.setData(response.result);
        this.paginator.setCurrentPage(1);
        activities = this.paginator.getCurrentPage();
      } else {
        activities = this.paginator.getNextPage();
      }

      this.removeLoader();

      if (!this.app.isEmpty(activities)) {
        _.each(activities, function (row) {
          if (!_.includes(['processed'], row.type)) {
            let $row = self.prepareRow(row);
            window.emailsIndexById[row.emailId] = row.email;
            $row.appendTo($listContainer);
          }


        });

        this.app.initTooltip();

        this.isRendering = false;

        let hasMoreData = this.paginator.hasMoreData();

        if (hasMoreData === false) {
          hasMoreData = this.paginatedUrl.hasMoreData();
          this.paginator.setCurrentPage(null);
        }

        return hasMoreData;

      } else if (this.total === 0) {
        const noRecordsOptions = {
          title: 'No Activity Found',
          class: 'available-card-viewport no-articles',
          description: 'Lead has no activity',
          help: {
            text: 'Need Help ?',
            onClick: () => {
              console.log('Help clicked');
              // Code to open help documentation or contact support
            }
          }
        };

        const placeholder = new NoRecordsPlaceholder(this.app, this.container.parent(), noRecordsOptions);
        placeholder.render();
      }

    } catch (error) {
      console.error("Error occurred during operation:", error);
    }
  }
}


class Lead extends TableList {
  templateName = 'insights__lead-view'
  tabLeadInfo = 'insights__tab-info'
  tabLeadActivity = 'insights__tab-activity'
  activityRow = 'insights__activity-row'
  activitiesFilter = 'insights__activities-filter'
  existingLeadCampaigns = 'insights__existing-lead-campaigns'

  constructor(app, container, imageCssVar, activeTab = 'Info') {
    super(app, container, 'insights__tab-info', false);

    this.app = app;
    this.container = container;
    this.template = _.template(this.app.templates[this.templateName]);
    this.data = {};
    this.activeTab = activeTab;
    this.menus = [
      'Info',
      'Activity'
    ];

    window['activitySearchParams'] = null;
  }

  setImageObserverManager(ImageObserverManager) {
    this.observerManager = ImageObserverManager;
  }

  setData(data) {
    this.data = data;

    const addressSource = this.data.address ? this.data : this.data.visualVisitor || {};

    console.log(this.data);

    const formattedInput = {
      contact_address: addressSource.address ?? '',
      contact_address_2: addressSource.address2 ?? '',
      contact_metro_city: addressSource.city ?? '',
      contact_state: addressSource.state ?? '',
      contact_zip: addressSource.zip ?? '',
      contact_zip4: addressSource.zip4 ?? '',
    };

    let sourceData = {};
    try {
      if (this.data.sourceData && this.data.sourceData.trim() !== '') {
        const parsed = JSON.parse(this.data.sourceData);
        if (parsed && typeof parsed === 'object') {
          sourceData = parsed;
          delete sourceData.SegmentName;
          delete sourceData.StiristaID;

        }
      }
    } catch (e) {
      console.warn('Invalid sourceData JSON:', e);
    }

    this.data.date_created = moment(moment.utc(this.data.dateCreated.date).toDate()).format('lll');
    this.data = {...this.data, ...{attributes: this.data.visualVisitor}, ...{sourceData: sourceData},...{formatAddress: this.formatAddress(formattedInput)}}
    this.data = {
      ...this.data,
      ...{unmailableReason: MdcDot.unmailableReason(this.data)},
      ...{unmailableType: MdcDot.unmailableType(this.data)},
      ...{stageClass: MdcDot.stageClass(this.data.stage)},
      ...{source: this.data.source === 'bulk_uploader' ? 'uploader' : this.data.source},
      ...{sourceClass: MdcDot.sourceClass(this.data.source)},
    }

    const activities = [
      'visit', 'click', 'open', 'delivered'
    ]

    const that = this;
    that.data.activitiesData = [];
    _.each(activities, function (activity) {
      that.data.activitiesData.push({
        'type': activity,
        'typeIcon': MdcDot.activityTypeClass(activity),
        'activityCount': Utils.staticPH,
      })
    });

    this.data = Utils.replaceEmptyValues(this.data);
  }

  formatAddress(address) {
    let formattedAddress;
    if (!this.app.isEmpty(address)) {
      formattedAddress = address.contact_address;

      if (!this.app.isEmpty(address.contact_address_2)) {
        formattedAddress += `, ${address.contact_address_2}`;
      }

      formattedAddress += `, ${address.contact_metro_city}, ${address.contact_state} ${address.contact_zip}`;

      if (!this.app.isEmpty(address.contact_zip4)) {
        formattedAddress += `-${address.contact_zip4}`;
      }
    } else {
      formattedAddress = 'N/A';
    }
    return formattedAddress;
  }

  updateData(key, value) {
    this.data[key] = value;
  }

  getData(data) {
    return {...this.data};
  }

  setMenus(menus) {
    this.menus = menus;
  }

  async getTabs() {
    let tabs = {};

    this.menus.forEach(function (tab) {
      const key = tab.replace(/\s/g, "_").toLowerCase();
      tabs[key] = {'key': tab.replace(/\s/g, "_").toLowerCase(), 'name': tab};
    })
    return {'menus': tabs};
  }

  initCampaignSelect2($parent, options) {
    const app = this.app;
    const $input = $parent.find(':input[name=campaign]');
    _.each(options, function (option) {
      const $option = $('<option>></option>').attr('value', option.id).text(option.name);
      $option.appendTo($input);
    })

    $input.select2({
      dropdownParent: $parent,
      dropdownCssClass: 'font-select2-dropdown',
      selectionCssClass: 'font-select2-selection',
      theme: 'bootstrap-5'
    });
  };

  renderExistingCampaigns(campaigns) {
    if (!this.app.isEmpty(campaigns)) {
      const template = _.template(this.app.templates[this.existingLeadCampaigns]);
      const $info = $(
          template({existingCampaigns: campaigns})
      );

      const $container = this.editor.find('[data-existing-campaigns]');
      $info.appendTo($container);
    }
  }

  renderLeadTags(tags) {
    const $container = this.editor.find('[data-lead-tags]');
    const template = _.template(this.app.templates['insights__tag-row']);
    _.each(tags, function (tag, index) {
      const $badge = $(template(tag));
      $badge.appendTo($container);
    });

  }

  renderCustomFields(customFields) {
    const $container = this.editor.find('[data-lead-custom-fields]');
    const template = _.template(this.app.templates['insights__custom-field-row']);
    _.each(customFields, function (field, index) {
      const $field = $(template(field));
      $field.appendTo($container);
    });
  }

  async renderTabInfo() {
    const app = this.app;
    const self = this;
    const $tabInfo = $('#tab_info', this.editor);

    const template = _.template(this.app.templates[this.tabLeadInfo]);

    this.showLoaderInto($tabInfo, {
      email: this.staticPH,
      mobilePhone: this.staticPH,
      formatAddress: this.staticPH,
      date_created: this.staticPH,
      source: this.staticPH,
      score: '',
      stage: this.staticPH,
      unmailable: false,
      unmailableType: '',
      unmailableReason: '',
      sourceClass: 'primary',
      stageClass: '',
      id: '',
      sourceData : '',
      iconClass : '',
      attributes: {
        gender: this.staticPH,
        age_range: this.staticPH,
        married: this.staticPH,
        homeowner: this.staticPH,
        children: this.staticPH,
        income_range: this.staticPH,
        net_worth: this.staticPH,
        visitor_search_engine: this.staticPH,
        contact_linkedin_url: ''
      }
    }, 1);

    const response = await this.app.apis['mdcdot'].leads.get(this.data.id);

    this.removeLoader();

    const $info = $(
        template(this.data)
    );
    $info.appendTo($tabInfo);

    this.initCampaignSelect2(this.editor, response.campaigns);
    this.renderExistingCampaigns(response.existingCampaigns);
    this.renderLeadTags(response.tags);
    this.renderCustomFields(response.customFields);

    // Rerender activity filter
    const mergedData = this.data.activitiesData.map(obj1 => {
      const obj2 = response.activities['data'].find(obj => obj.type === obj1.type) || {};
      return {...obj1, ...obj2};
    });

    this.data.activitiesData = mergedData;

    const $filter = this.renderActivityFilter();

    // Remove any placeholders
    $filter.find('.placeholder-glow').each(function () {
      $(this).parent().text(0);
    });

    new SimpleBar($tabInfo[0], {autoHide: true});
    return $info;
  }

  renderActivityFilter() {
    const $tabActivity = $('#tab_activity', this.editor);

    const templateFilter = _.template(this.app.templates[this.activitiesFilter]);

    const $filter = $(
        templateFilter(this.data)
    );

    const filterContainer = $tabActivity.find('[data-filter-activities]')
    filterContainer.empty();
    $filter.appendTo(filterContainer);
    return $filter;
  }

  async renderTabActivity() {
    const app = this.app;
    const self = this;
    const $tabActivity = $('#tab_activity', this.editor);

    const template = _.template(this.app.templates[this.tabLeadActivity]);

    const $activity = $(
        template(this.data)
    );

    $activity.appendTo($tabActivity);
    const container = $activity.find('[data-activites]');
    this.renderActivityFilter();

    new LeadActivity(this.app, container, this.data.id, this.activityRow)

    new SimpleBar($tabActivity[0], {autoHide: true});
    return $activity;
  }

  async updateTabActivity(activityTypes = {}) {
    this.app.request.abort();

    if (!this.app.isEmpty(activityTypes)) {
      const response = {'activityTypes': activityTypes}
      LeadActivity.filterCallback(response);
      window['activitySearchParams'] = response;
    } else {
      window['activitySearchParams'] = null;
    }

    const $tabActivity = $('#tab_activity', this.editor);
    const container = $tabActivity.find('[data-activites]');

    new LeadActivity(this.app, container, this.data.id, this.activityRow);

    new SimpleBar($tabActivity[0], {autoHide: true});
  }

  async render() {
    this.container.empty();
    const tabs = await this.getTabs();
    this.data = {...this.data, ...tabs, ...{'activeTab': this.activeTab}};
    const $editor = $(
        this.template(this.data)
    );
    this.editor = $editor.appendTo(this.container);

    if (this.menus.includes('Info')) {
      this.renderTabInfo();
    }

    if (this.menus.includes('Activity')) {
      this.renderTabActivity();
    }

    if (this.menus.length === 1) {
      this.editor.addClass('without-menus');
    } else {

    }

    this.app.initTooltip();
  }

  observe() {
    const self = this;
    const $observeManager = this.observerManager;
    let $images = $('.svg-object, .post-image', this.editor);
    $images.each(function (index, image) {
      const src = $(image).attr('data-src');
      if (!self.app.isEmpty(src)) {
        $observeManager.observeIntersection(image);
      }
    });
  }

  getInstance() {
    return {
      editor: this.editor
    }
  }
}

(function (aimi_mdcdot_leads, $, app, undefined) {
  // Private object
  let __this = {};


  aimi_mdcdot_leads.leadPayloadProcessor = function (requestData) {
    return requestData;
  }

  aimi_mdcdot_leads.leadSaveCallBack = function (response) {
    app.notifyEl.update({'message': response.message, progress: 100});
    // Identify and hide the modal window associated with the update action
    const $modal = response.$button.closest('.modal');
    // Refresh leads
    const $listContainer = $('[data-leads]');
    __this.listMananger = new LeadsList(app, $listContainer, 'insights__lead-row', 'dateCreated', 'DESC');
    app.hideModal($modal);
  }

  aimi_mdcdot_leads.newLeadModal = async function (leadData = {}) {
    let lead = {
      title: 'New Lead',
      saveButtonText: 'Save Lead',
      saveApi: 'mdcdot_lead.save'
    }

    if (!app.isEmpty(leadData) && !app.isEmpty(leadData.id)) {
      lead.id = leadData.id;
      lead.title = 'Edit Lead';
      lead.saveButtonText = 'Update Lead';
      lead.saveApi = 'mdcdot_lead.update';
      lead.mode = 'edit';

      lead.data = {};
    }

    app.inputPrompt({
      data: {
        ...lead, ...{

        }
      },
      type: "input",
      modalDialogClass: "modal-lg modal-dialog-centered modal-dialog-scrollable modal-new-lead",
      template: 'insights__new',
      title: lead.title,
      saveButtonText: lead.saveButtonText,
      footerText: '<span class="fw-semibold text-primary"></span>',
      saveApi: lead.saveApi,
      payloadProcessor: 'aimi_mdcdot_leads.leadPayloadProcessor',
      saveApiCallBack: 'aimi_mdcdot_leads.leadSaveCallBack'
    }).then(function ($modal) {
      app.addLeadModal = $modal;

      if (!app.isEmpty(lead.id)) {
        // Create the hidden input element
        const $hiddenInput = $('<input>', {
          type: 'hidden',
          name: 'campaignId',
          value: leadData.id
        });

        // Append the hidden input to the $modal body
        $modal.find('form').append($hiddenInput);

      }

    });
  }

  aimi_mdcdot_leads.tagsSaveCallback = function (response) {
    app.notifyEl.update({'message': response.message, progress: 100});
    // Identify and hide the modal window associated with the update action
    const $modal = response.$button.closest('.modal');
    app.hideModal($modal);

  }

  aimi_mdcdot_leads.tagsPayloadProcessor = function (requestData) {
    const leadSelection = MdcDot.getLeadSelection();

    if (!app.isEmpty(requestData.addTags)) {
      requestData.addTags = Utils.uniqueTags(requestData.addTags);
    }
    if (!app.isEmpty(requestData.removeTags)) {
      requestData.removeTags = Utils.uniqueTags(requestData.removeTags);
    }

    if (leadSelection.selection === 'all') {
      requestData.ids = [];
      const pageSize = 500;
      if (!app.isEmpty(requestData.addTags) || !app.isEmpty(requestData.removeTags)) {
        MdcDot.bulkProgressBar('tags', requestData, leadSelection.count, pageSize);
      }
    }
    return requestData;
  }

  aimi_mdcdot_leads.campaignPayloadProcessor = function (requestData) {
    const leadSelection = MdcDot.getLeadSelection();

    console.log(leadSelection);
    if (leadSelection.selection === 'all') {
      requestData.ids = [];
      const pageSize = 500;
      if (!app.isEmpty(requestData.addCampaign) || !app.isEmpty(requestData.removeCampaign)) {
        MdcDot.bulkProgressBar('campaign', requestData, leadSelection.count, pageSize);
      }
    }

    console.log(requestData);

    return requestData;
  }

  aimi_mdcdot_leads.campaignSaveCallback = function (response) {
    //Identify and hide the modal window associated with the update action
    if (!app.isEmpty(response.$button)) {
      app.notifyEl.update({'message': response.message, progress: 100});
      const $modal = response.$button.closest('.modal');
      app.hideModal($modal);
    }

  }

  aimi_mdcdot_leads.list = {
    listRow: 'insights__lead-row',
    dropify: function (namespace, $container) {
      const self = this;
      const title = 'File';
      const inputName = 'file';

      const options = {
        namespace: 'single-uploader', // Namespace for dropify instance
        title: ``,  // Title for the input field
        input: inputName, // ID and name of the input field
        preview: false,
        multiple: false,
        accept: '.csv',
        button: false,
        autoupload: true
      }
      const $uploader = new Uploader(app, $container, options, null);

      const processCallback = async function (response) {

      }

      // Function to check if the first object contains any of the specified keys
      function hasContactKey(arr) {
        if (arr.length === 0) return false; // Handle empty array

        const firstObject = arr[0];
        const keysToCheck = ['email', 'emailAddress', 'mobilePhone'];

        return keysToCheck.some((key) => key in firstObject);
      }

      const uploadCallback = async function (input, $button) {
        const file = input[0].files[0];
        app.doButtonAction($button);

        if (file) {
          Papa.parse(file, {
            header: true,
            dynamicTyping: true,
            complete: async function (results) {
              const data = Utils.convertArrayKeysToCamelCase(results.data);
              const hasEmail = hasContactKey(data);

              setTimeout(function () {
                app.doButtonReset($button, true);
              }, 500)

              if (hasEmail[0] === false) {
                app.infoModal('Invalid csv file', `File is missing key, column email or mobilePhone is required to proceed further`);
                return false;
              }

              results.dataCount = data.length;

              const pageSize = 50;
              const paginator = new Paginator(pageSize);
              paginator.setData(data);

              const totalPages = paginator.getTotalPages();

              let messages = [];
              for (let i = 0; i < totalPages; i++) {
                const startIndex = (i * pageSize) + 1;
                let endIndex = pageSize * (i + 1);
                endIndex = Math.min(endIndex, results.dataCount);
                messages.push(`Processing ${startIndex} - ${endIndex} of ${results.dataCount}`)
              }

              const page = _.template(app.templates['insights__leads-upload-progress']);
              $(page(results)).appendTo($container.find('.dropify-single-uploader'));

              const progress = new ProgressBar($container.find('.progressbar-container'), messages);

              // Function to create a delay
              const delay = function (ms) {
                return new Promise(resolve => setTimeout(resolve, ms));
              }

              for (let i = 0; i < totalPages; i++) {
                paginator.setCurrentPage(i + 1);
                const leads = paginator.getCurrentPage();

                progress.updateOneStep();

                // Create a new array with only the email and first name keys
                const previewData = leads.map(({email, first_name, last_name}) => ({email, first_name, last_name}));

                const leadPreviewContainer = $container.find('.leads-preview-container tbody');
                const page = _.template(app.templates['insights__leads-preview']);
                $(page({data: previewData})).prependTo(leadPreviewContainer);

                try {
                  const response = await app.apis['mdcdot'].leads.add({leads: leads});
                  await delay(2000); // Wait for 1 second
                  const exits = response.exist;
                  const added = response.added;

                  let $tr;
                  _.each(exits, function (lead, key) {
                    $tr = $(`[data-lead-upload][data-value="${key}"]`).closest('tr');
                    const $status = $tr.find('.col-status span');
                    const $info = $tr.find('.btn-upload-info');
                    $status.text('Already Exist');
                    $tr.addClass('exist');
                  });

                  _.each(added, function (lead, key) {
                    $tr = $(`[data-lead-upload][data-value="${key}"]`).closest('tr');
                    const $status = $tr.find('.col-status span');
                    const $info = $tr.find('.btn-upload-info');
                    if (!app.isEmpty(lead.success)) {
                      $status.text('Added');
                    } else {
                      $status.text('Error');
                      $info.attr('data-bs-original-title', lead.message);
                    }
                    $tr.addClass('added');
                  });

                } catch (e) {
                  console.log(e);
                }

                app.initTooltip();

              }


              progress.remove();
              $uploader.removeFlashMessage();

              // Refresh leads
              const $listContainer = $('[data-leads]');
              __this.listMananger = new LeadsList(app, $listContainer, self.listRow, 'dateCreated', 'DESC');
            }
          });
        }
      }

      return $uploader.dropifyFile(uploadCallback);
    },

    init: function (containerSelector = '.leads-container') {
      __this.containerRoot = containerSelector;

      const self = this;
      const $parentContainer = $(__this.containerRoot);
      const $listContainer = $('[data-leads]', $parentContainer);

      const page = _.template(app.templates['insights__tab-file-uploader']);
      $(page()).appendTo($parentContainer);

      $('.rows-selector-wrapper').find('button[data-lead-action]').attr('disabled', 'disabled');
      $parentContainer.find('.btn-sort').attr('disabled', 'disabled');

      __this.$leadsDropify = $('[data-uploader="file-uploader"]', $parentContainer);

      self.dropify('logo', __this.$leadsDropify);

      __this.listMananger = new LeadsList(app, $listContainer, self.listRow);

      let targetDrawer = '.hk-drawer.calendar-drawer';

      $(document).off('click.leads-view').on("click.leads-view", ".lead-row .btn-view", function (e) {
        let id = $(this).data('id');
        $(targetDrawer).css({
          "border": "none",
          "box-shadow": "0 8px 10px rgba(0, 0, 0, 0.1)"
        }).addClass('drawer-toggle');
        __this.lead = new Lead(app, $(targetDrawer).find('[data-lead]'), null);
        __this.lead.setData(window.leadsIndexById[id]);
        __this.lead.render();
        window.mdcdotLead = __this.lead;
        return false;
      });

      const uploaderEventManager = new EventManager('leads', `${__this.containerRoot} [data-uploader-action="expand"]`);
      uploaderEventManager.addEventListener('click', function () {
        let uploadsDrawer = '.hk-drawer.uploads-drawer';
        const $drawer = $(uploadsDrawer);
        $drawer.toggleClass('uploads-drawer-extended');
      });


      $(document).off('click.leads-sort').on("click.leads-sort", "[data-sort]", function (e) {
        const $this = $(this);
        let sortBy = $this.data('sort');
        let sortDirection = $this.attr('data-sort-direction');
        let $sortIcons = $('[data-sort] i');
        $sortIcons.removeClass('fa-arrow-down-short-wide fa-arrow-up-short-wide').addClass('fa-arrow-up-arrow-down');
        let $i = $this.find('i');
        if (sortDirection === 'ASC') {
          $i.addClass('fa-arrow-down-short-wide');
        } else {
          $i.addClass('fa-arrow-up-short-wide');
        }

        $this.attr('data-sort-direction', sortDirection === 'ASC' ? 'DESC' : 'ASC');
        __this.listMananger = new LeadsList(app, $listContainer, self.listRow, sortBy, sortDirection);
        return false;
      });


      const showMassAction = function () {
        const massOptions = {
          title: 'Mass Action',
          description: '',
          separator: false,
          exportButton: {
            text: 'Expor Csv',
            onClick: (e) => {
              const $button = $(e.currentTarget);
              const leadSelection = MdcDot.getLeadSelection();
              MdcDot.bulkProgressBar('export', {}, leadSelection.count, 500);
            }
          },
          tagButton: {
            text: 'Tag All',
            onClick: (e) => {
              const $button = $(e.currentTarget);
              // Collects all checked ids.
              const ids = $('input[name="ids[]"]:checked').map(function () {
                return this.value
              }).get();

              app.inputPrompt({
                type: 'input',
                modalDialogClass: 'modal-lg',
                template: 'insights__tags-prompt',
                title: 'Tag Leads',
                saveButtonText: 'Save',
                footerText: '<span class="fw-semibold"><span class="text-primary"> Note: </span> To create a new tag, type into the field and press return key</span>',
                payloadProcessor: 'aimi_mdcdot_leads.tagsPayloadProcessor',
                saveApi: 'mdcdot.tagMultiple',
                saveApiCallBack: 'aimi_mdcdot_leads.tagsSaveCallback'
              }).then(function (modal) {
                $('input[name="ids[]"]', modal).val(ids);
                $('input[name="ids[]"]', modal).val(ids);
                app.apis['mdcdot'].tags.list().done(function (response) {
                  const $addTags = $('select[name="addTags[]"]', modal);
                  const $removeTags = $('select[name="removeTags[]"]', modal);

                  let $options = response.result.map(option => `<option value="${option.tag}">${option.tag}</option>`).join('');
                  $addTags.html($options);

                  $options = response.result.map(option => `<option value="${option.id}">${option.tag}</option>`).join('');
                  $removeTags.html($options);

                  $('select', modal).each(function () {
                    const $select = $(this);
                    $select.attr('multiple', 'multiple');
                    $('.m-progress', modal).removeClass('m-progress');
                    $select.val([]).trigger('change');
                  });

                  $removeTags.select2({
                    dropdownCssClass: 'tags-select2-dropdown',
                    selectionCssClass: 'tags-select2-selection',
                    tags: true,
                    tokenSeparators: [',', ' '],
                    createTag: function (params, e) {
                      const term = $.trim(params.term);

                      // Check if the term is already in the predefined list
                      if (term === '' || $removeTags.find('option').filter(function () {
                        return $.trim($(this).text()) === term;
                      }).length === 0) {
                        return null; // Do not create a new tag
                      }

                      // Return the tag for creation
                      return {
                        id: term, text: term, newTag: true // Add a new tag indicator
                      };
                    }
                  });

                  $addTags.select2({
                    dropdownCssClass: 'tags-select2-dropdown',
                    selectionCssClass: 'tags-select2-selection',
                    tags: true,
                    tokenSeparators: [',', ' ']
                  });
                })
              });

            }
          },
          // deleteButton: {
          //   text: 'Delete All',
          //   onClick: (e) => {
          //     const leadSelection = MdcDot.getLeadSelection();
          //
          //     app.confirm('Delete leads?', 'Are you sure you want to delete  leads?').then(function (response) {
          //       const $button = response.button;
          //       const confirm = response.confirm;
          //       const $modal = response.modal;
          //
          //       // If the user confirms the deletion, proceed with the delete operation.
          //       if (confirm === true) {
          //         app.doButtonAction($button);
          //         console.log(leadSelection);
          //
          //         const requestData = {};
          //         if (leadSelection.selection === 'all') {
          //           requestData.ids = [];
          //           const pageSize = 500;
          //           MdcDot.bulkProgressBar('delete', requestData, leadSelection.count, pageSize);
          //         } else {
          //           // Collects all checked ids.
          //           let ids = $('input[name="ids[]"]:checked').map(function () {
          //             return this.value
          //           }).get();
          //           ids = ids.join(',');
          //           const requestData = {'ids': ids};
          //           app.apis['mdcdot'].leads.delete(requestData).done(function (response) {
          //             app.doButtonResetDelayed($button);
          //             const listManager = new LeadsList(app, $listContainer, 'insights__lead-row');
          //             listManager.onRenderList().then(function (leadResponse) {
          //               console.log(leadResponse);
          //             });
          //           });
          //
          //         }
          //
          //         app.doButtonReset($button);
          //         app.hideModal($modal);
          //       }
          //     });
          //   }
          // },
          campaignButton: {
            text: 'Add all to Campaign',
            onClick: (e) => {
              const $button = $(e.currentTarget);
              // Collects all checked ids.
              const ids = $('input[name="ids[]"]:checked').map(function () {
                return this.value
              }).get();

              app.inputPrompt({
                type: 'input',
                modalDialogClass: 'modal-lg',
                template: 'insights__campaigns-prompt',
                title: 'Assign Leads to Campaign',
                saveButtonText: 'Save',
                footerText: '',
                payloadProcessor: 'aimi_mdcdot_leads.campaignPayloadProcessor',
                saveApi: 'mdcdot.campaignMultiple',
                saveApiCallBack: 'aimi_mdcdot_leads.campaignSaveCallback'
              }).then(function (modal) {
                $('input[name="ids[]"]', modal).val(ids);
                app.asignLeadsToCampaignModal = modal;

                app.apis['mdcdot'].campaignLead.list().done(function (response) {
                  const $addCampaign = $('select[name="addCampaign"]', modal);
                  const $removeCampaign = $('select[name="removeCampaign"]', modal);

                  let $options = response.result.map(option => `<option value="${option.id}">${option.name}</option>`).join('');
                  $addCampaign.html($options);

                  $options = response.result.map(option => `<option value="${option.id}">${option.name}</option>`).join('');
                  $removeCampaign.html($options);

                  $('select', modal).each(function () {
                    const $select = $(this);
                    $('.m-progress', modal).removeClass('m-progress');
                    $select.val([]).trigger('change');
                  });

                  $addCampaign.select2({
                    dropdownCssClass: 'tags-select2-dropdown',
                    selectionCssClass: 'tags-select2-selection',
                  });

                  $removeCampaign.select2({
                    dropdownCssClass: 'tags-select2-dropdown',
                    selectionCssClass: 'tags-select2-selection',
                  });
                })
              });

            }
          }
        };

        const massActions = new MassActions(app, $('.table-leads [data-mass-actions]'), massOptions);
        massActions.render();
      }

      const setLeadsCount = function (count = 0) {
        const leadsCount = $('[data-leads-count]');
        if (count === 0) {
          count = $('tr.lead-row input[name="ids[]"]:checked').length;
        }

        if (count) {
          let suffix = 'leads';
          if (count === 1) {
            suffix = 'lead';
          }

          leadsCount.html(`<span class="fw-semibold">${count}</span> ${suffix}`);
        } else {
          leadsCount.html('');
        }
      }

      $(document).off('click.select-leads').on('click.select-leads', '[data-lead-action]', async function (e) {
        const $this = $(this);
        const action = $this.data('lead-action');

        MassActions.destroy();
        $('[data-lead-action=select-all-leads], [data-lead-action=select-all-leads-on-page],  [data-lead-action=deselect-all]')
            .attr('data-active', false).removeClass('btn-primary text-white');

        if (action === 'select-all-leads') {
          const $pageTitle = $('[data-count-all-leads]');
          $('tr.lead-row input[name="ids[]"]').prop('checked', true);
          const count = $pageTitle.data('count-all-leads');
          $this.attr('data-active', count).addClass('btn-primary text-white');
          setLeadsCount(count);
          showMassAction();
        }

        if (action === 'select-all-leads-on-page') {
          $('tr.lead-row input[name="ids[]"]').prop('checked', true);
          const count = $('tr.lead-row input[name="ids[]"]:checked').length;
          $this.attr('data-active', count).addClass('btn-primary text-white');
          setLeadsCount(count);
          showMassAction();
        }

        if (action === 'deselect-all') {
          $('tr.lead-row input[name="ids[]"]').prop('checked', false);
          const count = $('tr.lead-row input[name="ids[]"]:checked').length;
          $this.attr('data-active', count).addClass('btn-primary text-white');
          setLeadsCount();
        }

        if (action === 'add-leads') {
          let uploadsDrawer = '.hk-drawer.uploads-drawer';
          const $drawer = $(uploadsDrawer);
          $drawer.css({"border": "none", "box-shadow": "0 8px 10px rgba(0, 0, 0, 0.1)"}).toggleClass('drawer-toggle');
          return false;
        }

        if (action === 'add-lead') {
          aimi_mdcdot_leads.newLeadModal();
          return false;
        }

        if (action === 'filter') {
          let leadFilter = new LeadFilter();
          leadFilter.filter();
        }


        if (action === 'remove-tag') {
          app.doButtonAction($this);
          const tagId = $this.data('id');
          const leadData = __this.lead.getData();
          const id = leadData.id;
          const requestData = {'ids': [id], removeTags: [tagId]};
          const response = await app.apis['mdcdot'].tagMultiple(requestData);
          app.doButtonResetDelayed($this, true, 100);

          __this.lead = new Lead(app, $(targetDrawer).find('[data-lead]'), null);
          __this.lead.setData(window.leadsIndexById[id]);
          __this.lead.render();

        }


        if (action === 'search') {
          app.doButtonAction($this);
          const q = $this.closest('form').find(":input[name=q]");
          await LeadFilter.filterCallback({'q': q.val()});
          app.doButtonResetDelayed($this, true, 100);
        }

        if (action === 'add-to-campaign') {
          const id = $this.data('lead-id');
          app.doButtonAction($this);
          const campaignId = $(":input[name=campaign]", __this.lead.getInstance().editor).val();
          const requestData = {'ids': id, 'addCampaign': campaignId};
          const response = await app.apis['mdcdot'].leads.campaign(requestData);
          app.doButtonResetDelayed($this, true, 100);

          __this.lead = new Lead(app, $(targetDrawer).find('[data-lead]'), null);
          __this.lead.setData(window.leadsIndexById[id]);
          __this.lead.render();
        }

        if (action === 'remove-from-campaign') {
          const leadData = __this.lead.getData();
          const id = leadData.id;
          const campaignId = $this.data('campaign-id');
          app.doButtonAction($this);
          const requestData = {'ids': id, 'removeCampaign': campaignId};
          const response = await app.apis['mdcdot'].leads.campaign(requestData);
          app.doButtonResetDelayed($this, true, 100);

          __this.lead = new Lead(app, $(targetDrawer).find('[data-lead]'), null);
          __this.lead.setData(window.leadsIndexById[leadData.id]);
          __this.lead.render();
        }

        if (action === 'unsubscribe') {
          const leadId = $this.data('lead-id');
          app.doButtonAction($this);
          const requestData = {'ids': leadId};
          const response = await app.apis['mdcdot'].leads.unsubscribe(requestData);

          const leadData = __this.lead.getData();
          app.doButtonResetDelayed($this, true, 100);

          __this.lead = new Lead(app, $(targetDrawer).find('[data-lead]'), null);
          __this.lead.setData(window.leadsIndexById[leadData.id]);
          __this.lead.render();
        }

      });

      $(document).off('change.leads_click').on('change.leads_click', 'tr.lead-row input[name="ids[]"]', function (e) {

        MassActions.destroy();
        // Collects all checked ids.
        const ids = $('input[name="ids[]"]:checked').map(function () {
          return this.value
        }).get();

        setLeadsCount();

        // Check if any hashtags were selected for deletion.
        if (ids.length === 0) {

        } else {
          showMassAction();
        }
      });

      $(document).off('click.lead_delete').on('click.lead_delete', 'tr:not(.pre-loader) .btn-delete', function (e) {
        const $this = $(this);
        let id = $this.data('id');
        let $item = $this.closest('tr.lead-row');

        app.confirm("Delete Lead?", "Are you sure you want to delete this Lead?").then(function (response) {
          const $button = response.button;
          const confirm = response.confirm;
          const $modal = response.modal;

          // If the user confirms the deletion, proceed with the delete operation.
          if (confirm === true) {
            app.doButtonAction($button);
            const requestData = {'ids': id};
            app.apis['mdcdot'].leads.delete(requestData).done(function (response) {
              if (response.success !== true) {
                const message = response.message;
                app.infoModal('Not Deleted', message);
              } else {
                app.removeItem($item, 'slideOutRight');
              }
              app.doButtonResetDelayed($button);
              app.hideModal($modal);
            }).fail(function (response) {
              app.doButtonReset($button, false);
              app.hideModal($modal);
            });
          }
        });
      });

      app.initSimpleBar($('#tab_block_1')[0]);

      // Event for instance switch
      $(document).off('submit.mdcdot_instance_user').on('submit.mdcdot_instance_user', 'form[name=mdcdot_instance_user]', function (e) {
        const $form = $(this);
        console.log($form);
      })

      $(document).off('change.mdcdot_instance_user').on('change.mdcdot_instance_user', 'form[name=mdcdot_instance_user] select', function (e) {
        const $form = $('form[name=mdcdot_instance_user]');
        console.log($form);
        $form.submit();
        return e.preventDefault();
      })
    }

  }
}(window.aimi_mdcdot_leads = window.aimi_mdcdot_leads || {}, jQuery, PreBuilt));

class LeadFilter {

  static async filterCallback(response) {
    const app = PreBuilt;

    let stage = response.score;
    if (!app.isEmpty(stage)) {
      stage = stage.split(';');

      stage = stage.map(t => t.trim());
      if (!app.isEmpty(stage[0])) {
        response.score = stage;
      } else {
        delete response.score;
      }
    }

    let range = response.range;
    if (!app.isEmpty(range)) {
      range = range.split(' - ');
      range = range.map(date => date.trim());
      if (!app.isEmpty(range[0])) {
        response.range = range;
      } else {
        delete response.range;
      }
    }

    window['leadSearchParams'] = response;

    const $listContainer = $('[data-leads]');
    const listManager = new LeadsList(app, $listContainer, 'insights__lead-row');
    listManager.onRenderList().then(function (leadResponse) {

    });


    NoRecordsPlaceholder.destroy();
    Toast.destroy();
    if (!app.isEmpty(app.filterModal)) {
      app.filterModal.modal('hide');
    }

    let message = [];
    const messageStatic = `Showing results for filters with `;
    if (!app.isEmpty(response.score)) {
      const scores = response.score.join(',')
      message.push(` <span class="fw-semibold">score ${scores}</span>`)
    }

    if (!app.isEmpty(response.stage)) {
      const stages = response.stage.join(',')
      message.push(` <span class="fw-semibold">stage ${stages}</span>`)
    }

    if (!app.isEmpty(response.source)) {
      const sources = response.source.join(',')
      message.push(` <span class="fw-semibold">source ${sources}</span>`)
    }

    if (!app.isEmpty(response.tags)) {
      const tags = response.tags.join(',')
      message.push(` <span class="fw-semibold">tags ${tags}</span>`)
    }

    if (!app.isEmpty(response.q)) {
      const q = response.q;
      message.push(` <span class="fw-semibold">search ${q}</span>`)
    }

    if (!app.isEmpty(response.mailable)) {
      const mailable = response.mailable;
      message.push(` <span class="fw-semibold">${mailable}</span>`)
    }

    if (!app.isEmpty(range)) {
      message.push(`<span class="fw-semibold"> date range ${range[0]} to ${range[1]} </span>`);
    }
    message = messageStatic + message.join(' and ');
    app.Toast = new Toast(app, $listContainer.closest('.table-leads'), {
      'toastClass': 'mb-5 position-sticky top-0',
      'message': message, closeButton: {
        text: 'Clear Filter',
        onClick: () => {
          Toast.destroy();
          window['leadSearchParams'] = null;
          const listManager = new LeadsList(app, $listContainer, 'insights__lead-row');
          listManager.onRenderList().then(function (leadResponse) {
            console.log(leadResponse);
          });
        }
      }
    });
    app.Toast.render();
  }

  async filter() {
    const app = PreBuilt;
    const options = {
      modalDialogClass: 'modal-xl  modal-dialog-scrollable modal-dialog-centered  modal-filter-posts',
      template: 'insights__filter-leads',
      title: 'Filter Leads',
      saveButtonText: 'Filter',
      footerText: '',
      saveApi: '',
      saveApiCallBack: 'LeadFilter.filterCallback',
    };

    app.inputPrompt(options).then(async function ($modal) {
      app.filterModal = $modal;
      const progress = new ProgressBar($modal.find('.container-fluid'));
      progress.start();


      const $scoreInput = $modal.find('input[name=score]');
      $scoreInput.ionRangeSlider({
        type: "double",
        min: 0,
        max: 10000,
        from: 0,
        to: 10000,
        keyboard: true,
        onStart: function (data) {
          console.log("onStart");
        },
        onChange: function (data) {
          console.log("onChange");
        },
        onFinish: function (data) {
          console.log("onFinish");
        },
        onUpdate: function (data) {
          console.log("onUpdate");
        }
      });


      const $input = $modal.find('input[name=range]');
      const picker = new easepick.create({
        element: $input[0],
        zIndex: 1200,
        calendars: 3,
        grid: 3,
        plugins: [
          "RangePlugin",
          "LockPlugin"
        ],
        LockPlugin: {
          minDays: 2,
          maxDays: 90,
        },
        css: ['https://cdn.jsdelivr.net/npm/@easepick/bundle@1.2.1/dist/index.css'],
        inline: true
      });

      const stages = await app.apis['mdcdot'].stages.list();
      const $stages = $('[data-stages]', $modal);
      let $stageHtml = '';
      let stagesCount = 0;
      _.each(stages.result, function (stage) {
          stagesCount++;
           $stageHtml += `<div class="btn-group " role="group">
            <input type="checkbox" name="stage[]" id="stage-${stage.stage}"
                   class="form-check-input btn-check position-absolute top-0 bottom-0 m-auto ms-3" autocomplete="off"
                   value="${stage.stage}">
            <label class="btn btn-outline-primary ms-1" style="border-color:#${stage.color};" for="stage-${stage.stage}">${stage.name}</label>
          </div>`
      })

      $stages.removeClass('m-progress');
      $stages.addClass(`row-cols-${stagesCount}`);
      $stages.html($stageHtml);

      const response = await app.apis['mdcdot'].tags.list();
      const $tags = $('select[name="tags[]"]', $modal);

      let $options = response.result.map(option => `<option value="${option.id}">${option.tag}</option>`).join('');
      $tags.html($options);

      $('select', $modal).each(function () {
        const $select = $(this);
        $select.attr('multiple', 'multiple');
        $('.m-progress', $modal).removeClass('m-progress');
        $select.val([]).trigger('change');
      });

      $tags.select2({
        dropdownCssClass: 'tags-select2-dropdown',
        selectionCssClass: 'tags-select2-selection',
        tags: true,
        tokenSeparators: [',', ' '],
        createTag: function (params, e) {
          const term = $.trim(params.term);

          // Check if the term is already in the predefined list
          if (term === '' || $tags.find('option').filter(function () {
            return $.trim($(this).text()) === term;
          }).length === 0) {
            return null; // Do not create a new tag
          }

          // Return the tag for creation
          return {
            id: term, text: term, newTag: true // Add a new tag indicator
          };
        }
      });

      progress.remove();


    });
  }
}

// Creating a map of class references
window["LeadFilter"] = LeadFilter;

$(document).off('click.activity-action').on("click.activity-action", "[data-activity-action]", function (e) {
  const $this = $(this);
  let id = $this.data('id');
  let action = $this.attr('data-activity-action');
  let leadId = $this.data('lead-id');
  const app = PreBuilt;

  if (action === 'email') {
    const email = window.emailsIndexById[id];

    const $modal = app.infoModal('Email Preview', `<object  class="email-preview"  data="/api/mdcdot/lead/${leadId}/email/${id}" > </object>`, {dialogClass: 'modal-lg modal-dialog-scrollable modal-email-preview'});

    // Get the object element
    let objectElement = document.querySelector('.email-preview');

    // Listen for the onload event
    objectElement.onload = function () {
      progress.remove();
      objectElement.classList.add('loaded');
    };

    const progress = new ProgressBar($modal.find('.modal-body'));
    progress.start();
  }

  if(action === 'email-variant') {
    const aimiEmailCampaignId = $this.attr('data-aimi-email-campaign-id');
    const emailVariantId = $this.attr('data-email-variant-id');

    previewEmailVariant(emailVariantId, aimiEmailCampaignId, leadId);
  }

  if (action === 'filter') {
    $this.toggleClass('btn-outline-primary');
    // Select all matching elements
    const activityTypes = $('[data-activity-action="filter"].btn-outline-primary').map(function () {
      return $(this).attr('data-activity');
    }).get();
    window.mdcdotLead.updateTabActivity(activityTypes);
  }
});

